import { render, staticRenderFns } from "./PiperineExtract.vue?vue&type=template&id=1f189734&scoped=true&"
import script from "./PiperineExtract.vue?vue&type=script&lang=js&"
export * from "./PiperineExtract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f189734",
  null
  
)

export default component.exports